define(function (require) {
    'use strict';

    var Marionette = require('marionette');
    var Template = require('text!tmpls/save_page.tpl').default;
    var AppConfig = require('config/application');

    var I18n = require('i18n!nls/main');

    return Marionette.ItemView.extend({
        template: Template,

        ui: {
            btnSave: '.js-btn-save',
            btnCancel: '.js-btn-cancel',
            spinner: '.js-spinner'
        },

        events: {
            'click @ui.btnSave': 'Save',
            'click @ui.btnCancel': 'Cancel',
        },

        onShow: function() {
            this.ui.btnSave.prop('disabled', this.options.disabled);
            this.ui.btnCancel.prop('disabled', this.options.disabled);
        },

        Save: function () {
            this.ui.btnSave.prop('disabled', true);
            this.ui.btnCancel.prop('disabled', true);
            this.ui.spinner.css('display', 'inline-block');
            //app.curPage.Save();
            this.trigger('save');
        },

        Cancel: function () {
            //app.curPage.Cancel();
            this.trigger('cancel');
        },

        showSpinner() {
            this.ui.btnSave.prop('disabled', true);
            this.ui.btnCancel.prop('disabled', true);
            this.ui.spinner.css('display', 'inline-block');
        }
    });
});
